module.exports = __webpack_public_path__ + "static/vigo-aa609ffd9d13c4b94c49f9a9225c1e04.png";